function I(e) {
  const n = "[a-zA-Z_\\-+\\*\\/<=>&#][a-zA-Z0-9_\\-+*\\/<=>&#!]*", t = "\\|[^]*?\\|", c = "(-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|-)?\\d+)?", o = {
    className: "literal",
    begin: "\\b(t{1}|nil)\\b"
  }, a = {
    className: "number",
    variants: [
      {
        begin: c,
        relevance: 0
      },
      { begin: "#(b|B)[0-1]+(/[0-1]+)?" },
      { begin: "#(o|O)[0-7]+(/[0-7]+)?" },
      { begin: "#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?" },
      {
        begin: "#(c|C)\\(" + c + " +" + c,
        end: "\\)"
      }
    ]
  }, s = e.inherit(e.QUOTE_STRING_MODE, { illegal: null }), E = e.COMMENT(
    ";",
    "$",
    { relevance: 0 }
  ), l = {
    begin: "\\*",
    end: "\\*"
  }, g = {
    className: "symbol",
    begin: "[:&]" + n
  }, i = {
    begin: n,
    relevance: 0
  }, N = { begin: t }, r = {
    contains: [
      a,
      s,
      l,
      g,
      {
        begin: "\\(",
        end: "\\)",
        contains: [
          "self",
          o,
          s,
          a,
          i
        ]
      },
      i
    ],
    variants: [
      {
        begin: "['`]\\(",
        end: "\\)"
      },
      {
        begin: "\\(quote ",
        end: "\\)",
        keywords: { name: "quote" }
      },
      { begin: "'" + t }
    ]
  }, T = { variants: [
    { begin: "'" + n },
    { begin: "#'" + n + "(::" + n + ")*" }
  ] }, b = {
    begin: "\\(\\s*",
    end: "\\)"
  }, d = {
    endsWithParent: !0,
    relevance: 0
  };
  return b.contains = [
    {
      className: "name",
      variants: [
        {
          begin: n,
          relevance: 0
        },
        { begin: t }
      ]
    },
    d
  ], d.contains = [
    r,
    T,
    b,
    o,
    a,
    s,
    E,
    l,
    g,
    N,
    i
  ], {
    name: "Lisp",
    illegal: /\S/,
    contains: [
      a,
      e.SHEBANG(),
      o,
      s,
      E,
      r,
      T,
      b,
      i
    ]
  };
}
export {
  I as default
};
